<template>
    <div>
        <loading
            :active.sync="loadingApp"
            :can-cancel="false"
            :is-full-page="true"
            :color="'#0B8BCC'"
            :loader="'dots'"
            :opacity="0.7"
            :lock-scroll="true"
        ></loading>
        <Toast
            :show.sync="toast.show"
            :message="toast.message"
            :tipe="toast.tipe"
            @close="toast.show = false"
            :position="toast.position"
            :icon="toast.icon"
        ></Toast>
        <!-- App Header -->
        <div class="appHeader bg-primary text-light">
            <div class="left">
                <a
                    href="Javascript:;"
                    class="headerButton"
                    @click="$router.go(-1)"
                >
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </a>
            </div>
            <div class="pageTitle">Detail Pencairan QRIS</div>
        </div>
        <!-- * App Header -->

        <div id="appCapsule" class="pb-0" v-if="loadingApp == false">
            <div>
                <div
                    class="section detail-transaction-section pt-4"
                    style="--height: 150px"
                >
                    <div class="detail-card">
                        <div class="listed-detail mt-1">
                            <div class="text-center">
                                <div>
                                    <small>Pencairan Saldo QRIS</small>
                                </div>
                                <h1
                                    class="text-center"
                                    style="font-weight: bold"
                                >
                                    Rp
                                    {{
                                        qris_settlement_detail.total_amount_disbursed
                                            | rupiah
                                    }}
                                </h1>
                                <div>
                                    <label
                                        class="badge badge-warning pl-2 pr-2"
                                        v-if="
                                            qris_settlement_detail.status ==
                                            'waiting'
                                        "
                                        >Menunggu</label
                                    >
                                    <label
                                        class="badge badge-primary pl-2 pr-2"
                                        v-else-if="
                                            qris_settlement_detail.status ==
                                            'process'
                                        "
                                        >Sedang diproses</label
                                    >
                                    <label
                                        class="badge badge-success pl-2 pr-2"
                                        v-else-if="
                                            qris_settlement_detail.status ==
                                            'success'
                                        "
                                        >Berhasil</label
                                    >
                                </div>
                            </div>
                        </div>
                        <div class="listed-detail mt-1">
                            <table class="table-detail">
                                <tr>
                                    <td width="150px" class="label-td">
                                        Tanggal Dibuat
                                    </td>
                                    <td width="20px">:</td>
                                    <td class="label-td">
                                        {{
                                            qris_settlement_detail.created_at
                                                | date
                                        }}
                                        ({{
                                            qris_settlement_detail.created_at
                                                | time
                                        }}
                                        WIB)
                                    </td>
                                </tr>
                                <tr>
                                    <td width="150px" class="label-td">
                                        Merchant ID (NMID)
                                    </td>
                                    <td width="20px">:</td>
                                    <td class="label-td">
                                        <b>{{
                                            qris_settlement_detail.qris_merchant
                                                .merchant_id
                                        }}</b>
                                    </td>
                                </tr>
                                <tr>
                                    <td width="150px" class="label-td">
                                        Nama Merchant
                                    </td>
                                    <td width="20px">:</td>
                                    <td class="label-td">
                                        <b>{{
                                            qris_settlement_detail.qris_merchant
                                                .merchant_name
                                        }}</b>
                                    </td>
                                </tr>

                                <tr>
                                    <td width="150px" class="label-td">
                                        Total Jumlah
                                    </td>
                                    <td width="20px">:</td>
                                    <td class="label-td">
                                        <b
                                            >Rp
                                            {{
                                                qris_settlement_detail.total_amount
                                                    | rupiah
                                            }}</b
                                        >
                                    </td>
                                </tr>
                                <tr>
                                    <td width="150px" class="label-td">
                                        Total Biaya (MDR)
                                    </td>
                                    <td width="20px">:</td>
                                    <td class="label-td">
                                        Rp
                                        {{
                                            qris_settlement_detail.total_fee
                                                | rupiah
                                        }}
                                    </td>
                                </tr>
                                <tr>
                                    <td width="150px" class="label-td">
                                        Total Biaya Percepatan
                                    </td>
                                    <td width="20px">:</td>
                                    <td class="label-td">
                                        Rp
                                        {{
                                            qris_settlement_detail.total_fee_fast_settlement
                                                | rupiah
                                        }}
                                    </td>
                                </tr>
                                <tr>
                                    <td width="150px" class="label-td">
                                        Total Dicairkan
                                    </td>
                                    <td width="20px">:</td>
                                    <td class="label-td">
                                        Rp
                                        {{
                                            qris_settlement_detail.total_amount_disbursed
                                                | rupiah
                                        }}
                                    </td>
                                </tr>
                                <tr>
                                    <td width="150px" class="label-td">
                                        Estimasi Pencairan
                                    </td>
                                    <td width="20px">:</td>
                                    <td class="label-td">
                                        {{
                                            qris_settlement_detail.settlement_date
                                                | date
                                        }}
                                        ({{
                                            qris_settlement_detail.settlement_date
                                                | time
                                        }}
                                        WIB)
                                    </td>
                                </tr>
                                <tr>
                                    <td width="150px" class="label-td">
                                        Jenis Pencairan
                                    </td>
                                    <td width="20px">:</td>
                                    <td class="label-td">
                                        <div
                                            v-if="
                                                qris_settlement_detail.settlement_type ==
                                                'early_settlement'
                                            "
                                            class="text-warning"
                                        >
                                            <ion-icon
                                                name="flash-outline"
                                            ></ion-icon>
                                            Dipercepat
                                        </div>
                                        <div v-else class="text-secondary">
                                            Normal
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td width="150px" class="label-td">
                                        Tanggal Selesai
                                    </td>
                                    <td width="20px">:</td>
                                    <td
                                        class="label-td"
                                        v-if="
                                            qris_settlement_detail.settled_at !=
                                            null
                                        "
                                    >
                                        {{
                                            qris_settlement_detail.settled_at
                                                | date
                                        }}
                                        ({{
                                            qris_settlement_detail.settled_at
                                                | time
                                        }}
                                        WIB)
                                    </td>
                                    <td v-else class="label-td">-</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- dialog Clear Cache -->
        <Dialog
            ref="dialog_alert_coming"
            :loading="false"
            :title="'Informasi'"
            @confirm="showAlertComing('hide')"
            :icon="'warning'"
        >
            <span class="text-standar"
                >Fitur ini masih dalam pengembangan dan akan segera tersedia,
                saat fitur ini sudah tersedia akan kami informasikan.</span
            >
        </Dialog>
    </div>
</template>
<script>
    import { mapActions, mapState, mapMutations } from 'vuex';
    export default {
        data() {
            return {
                loadingApp: false,
            };
        },
        created() {
            this.loadingApp = true;
            this.getQrisSettlementDetail(this.$route.params.id).then(() => {
                this.loadingApp = false;
            });
        },
        computed: {
            ...mapState(['toast', 'VUE_ENV', 'customer', 'setting']),
            ...mapState('qrisMerchant', {
                qris_settlement_detail: state => state.qris_settlement_detail,
                loading: state => state.loading,
            }),
        },
        methods: {
            ...mapActions('qrisMerchant', ['getQrisSettlementDetail']),
            ...mapMutations('qrisMerchant', ['RESET_QRIS_SETTLEMENT_DETAIL']),
        },

        mounted() {},
        destroyed() {
            this.RESET_QRIS_SETTLEMENT_DETAIL();
        },
    };
</script>
